<div class="jobContainer">
  <div class="p-3">
    <div class="form-row form-group">
      <div class="col-md-3">
        <div class="input-group">
          <input type="text" #searched class="form-control bg-dark border-dark text-light" placeholder="Search video id, channel"
          (change)="jobSearchChange($event, searched.value)" list="channels">

          <div class="input-group-append">
            <ng-container *ngIf="manualChannel?.chanel_name">
              <span class="input-group-text bg-dark border-dark text-light">{{manualChannel?.chanel_name}}</span>

              <span *ngIf="viewType == 1" (click)="reloadJob({ chanel_id: 'search', chanel_name: null })" class="input-group-text bg-dark border-dark text-light px-0" role="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                  <path
                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                </svg>
              </span>
            </ng-container>

            <span (click)="clearJobSearch(); searched.value=''" class="input-group-text bg-dark border-dark text-light" role="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                viewBox="0 0 16 16">
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
              </svg>
            </span>
          </div>
        </div>

        <datalist id="channels">
          <option *ngFor="let item of channelList" [value]="item?.chanel_id">{{ item?.chanel_name }}</option>
        </datalist>
      </div>

      <div class="col-md-1 ml-auto">
        <div class="btn-group btn-block" role="group">
          <button type="button" class="btn btn-dark" (click)="crosspostResults()">Crossposts</button>
          <button *ngIf="reqType == 'views-crosspost'" type="button" class="btn btn-dark" (click)="clearCrosspostResults()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
              viewBox="0 0 16 16">
              <path
                d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="form-row" *ngIf="viewType != 1">
      <div class="col-md d-flex align-items-center overflow-scroll">
        <ng-container *ngFor="let item of job?.stats">
          <button type="button" class="btn btn-dark text-nowrap mr-2" (click)="scrollspy(item?.chanel_id)"
            *ngIf="item?.error_count > 0">
            {{ item?.chanel_name }} <span class="badge badge-danger">{{ item?.error_count }}</span>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="text-center" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="loadMore(job[manualChannel?.chanel_id]?.page, manualChannel, searched.value)"
    *ngIf="viewType == 2 && job[manualChannel?.chanel_id]?.results.length">
    <table class="table table-dark table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Name</th>
          <th scope="col">Channel</th>
          <th scope="col">Video</th>
          <th scope="col">Thumbnail</th>
          <th scope="col">Meta upload</th>
          <th scope="col">Upload</th>
          <th scope="col">Music status</th>
          <th scope="col">Job status</th>
          <th scope="col">Render progress</th>
          <th scope="col">Status</th>
          <th scope="col">Created</th>
          <th scope="col">Crosspost user</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of job[manualChannel?.chanel_id]?.results">
          <th scope="row">
            <a class="text-light" rel="nofollow" target="_blank" href="/?loadId={{ item?.id }}">
              {{ item?.id }}
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                class="bi bi-pencil-fill" viewBox="0 0 16 16">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
              </svg>
            </a>
          </th>
          <td>{{ item?.name }}</td>
          <td>
            <a class="text-light" rel="nofollow" target="_blank"
              href="https://www.youtube.com/channel/{{ item?.channel_id }}">
              {{ item?.channel_name }}
            </a>
          </td>
          <td>
            <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
              [href]="item?.result?.startsWith('http') ? (item?.result | split:';;':0) : 'https://drive.google.com/file/d/' + (item?.result | split:';;':0) + '?sv=studio'">
              Download
            </a>
            <button *ngIf="item?.result != '' && !item?.result?.startsWith('http')" (click)="archiveDrive(item)" title="Move to archive (ignore remove by system)"
              class="btn btn-block btn-sm btn-secondary" type="button">Archive</button>
          </td>
          <td>
            <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
              [href]="item?.result?.includes(';;http') ? (item?.result | split:';;':1) : 'https://drive.google.com/uc?id=' + (item?.result | split:';;':1)">
              Download
            </a>
          </td>
          <td>
            <div class="font-weight-bold mb-2">
              <span *ngIf="item.reup_config?.schedule?.date">{{item.reup_config.schedule | scheduleDate}} {{item.reup_config.schedule.time}}</span>
              <span *ngIf="!item?.reup_config">Not scheduled yet</span>
            </div>
            <div *ngIf="item?.reup_config">
              <button type="button" class="btn btn-sm btn-secondary m-1" data-toggle="modal" data-target="#metaModal"
                (click)="getMeta(item)">Show</button>
              <button type="button" class="btn btn-sm btn-warning m-1"
                (click)="stopUpload(item)">Stop</button>
            </div>
          </td>
          <td>
            <a class="text-truncate" *ngIf="item?.upload_status == 3 && item?.client_status != 0; else elseBlock"
              rel="nofollow" target="_blank" href="https://www.youtube.com/watch?v={{ item?.upload_log }}">
              {{ item?.upload_log }}
            </a>
            <ng-template #elseBlock>{{ item?.upload_log }}</ng-template>
          </td>
          <td class="font-weight-bold">{{ getMusicStatus(item) }}</td>
          <td>
            <span *ngIf="item?.type == 4" class="badge badge-pill badge-info mr-1">Test</span>
            <span class="badge badge-pill"
              [ngClass]="{ 'badge-danger': item?.status == 71 || (item?.status == 5 && item?.upload_status == 4), 'badge-success': item?.status == 6 || (item?.status == 5 && item?.upload_status == 3) || item?.status == 3, 'badge-primary': item?.status == 4, 'badge-info': item?.status == 2, 'badge-warning': item?.status == 7 || item?.status == 1 || item?.status == 0 }">
              {{ item?.status == 71 ? 'Render Error' : item?.status == 7 ? 'Stopped' : item?.status == 6 ? 'Scheduled' :
              item?.status == 5 && item?.upload_status == 4 ? 'Up Failed' : item?.status == 5 && item?.upload_status ==
              3 ? 'Uploaded' : item?.status == 4 ? 'Uploading' : item?.status == 3 ? 'Rendered' : item?.status == 2 ?
              'Running' : item?.status == 1 ? 'Assigned' : 'New' }}
            </span>
            <div *ngIf="item?.status == 71 || item?.upload_status == 4" class="mt-2">
              <button *ngIf="item?.status == 71" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                (click)="retryJob(item)">Retry Job</button>
              <button *ngIf="item?.upload_status == 4" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                (click)="retryUpload(item)">Retry Upload</button>
            </div>
            <div *ngIf="item?.type == 4 && item?.status == 3" class="mt-2">
              <button type="button" class="btn btn-sm btn-primary text-nowrap m-1" [disabled]="item?.isUploading" (click)="uploadNow(item)">Upload now</button>
            </div>
          </td>
          <td>
            <div class="progress" *ngIf="item?.render_percent != null">
              <div class="progress-bar progress-bar-striped bg-primary" role="progressbar"
                [style.width.%]="item?.render_percent | round:0" [attr.aria-valuenow]="item?.render_percent | round:0"
                aria-valuemin="0" aria-valuemax="100">
                {{ item?.render_percent | round:0 }}%
              </div>
            </div>
          </td>
          <td>
            <span class="{{ item?.success == 1 || item?.upload_status == 3 ? 'text-success' : 'text-danger' }}"
              *ngIf="item?.success != null || item?.upload_status != 0">
              {{ item?.success == 1 ? 'RENDER SUCCESS' : item?.upload_status == 3 ? 'UPLOAD SUCCESS' : 'ERROR' }}
            </span>
            <div *ngIf="item?.success != null && item?.success != 1 && item?.upload_status != 3">
              <button (click)="askError(item)" type="button" class="btn btn-sm btn-info mt-1" [disabled]="askErrorData.isLoading == item.id">
                <span *ngIf="askErrorData.isLoading == item.id" class="spinner-border spinner-border-sm"></span>
                <svg *ngIf="askErrorData.isLoading != item.id" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16">
                  <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
                </svg>
                Moon AI
              </button>
            </div>
          </td>
          <td>{{ item?.created }}</td>
          <td>{{ item?.crosspost_user }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="loadMore(job?.search?.page, 'search', searched.value)"
    *ngIf="viewType == 1 && job?.search?.results.length">
    <table class="table table-dark table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Name</th>
          <th scope="col">Channel</th>
          <th scope="col">Video</th>
          <th scope="col">Thumbnail</th>
          <th scope="col">Meta upload</th>
          <th scope="col">
            <div class="d-flex align-items-center justify-content-between">
              Upload
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-trash text-danger c-pointer" viewBox="0 0 16 16" (click)="deleteVideos('search')"
                *ngIf="deleteData['search']?.video_ids?.length">
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
              </svg>
            </div>
          </th>
          <th scope="col">Music status</th>
          <th scope="col">Job status</th>
          <th scope="col">Render progress</th>
          <th scope="col">Status</th>
          <th scope="col">Created</th>
          <th scope="col">Crosspost user</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of job?.search?.results">
          <th scope="row">
            <a class="text-light" rel="nofollow" target="_blank" href="/?loadId={{ item?.id }}">
              {{ item?.id }}
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                class="bi bi-pencil-fill" viewBox="0 0 16 16">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
              </svg>
            </a>
          </th>
          <td>{{ item?.name }}</td>
          <td>
            <a class="text-light" rel="nofollow" target="_blank"
              href="https://www.youtube.com/channel/{{ item?.channel_id }}">
              {{ item?.channel_name }}
            </a>
          </td>
          <td>
            <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
              [href]="item?.result?.startsWith('http') ? (item?.result | split:';;':0) : 'https://drive.google.com/file/d/' + (item?.result | split:';;':0) + '?sv=studio'">
              Download
            </a>
            <button *ngIf="item?.result != '' && !item?.result?.startsWith('http')" (click)="archiveDrive(item)" title="Move to archive (ignore remove by system)"
              class="btn btn-block btn-sm btn-secondary" type="button">Archive</button>
          </td>
          <td>
            <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
              [href]="item?.result?.includes(';;http') ? (item?.result | split:';;':1) : 'https://drive.google.com/uc?id=' + (item?.result | split:';;':1)">
              Download
            </a>
          </td>
          <td>
            <div class="font-weight-bold mb-2">
              <span *ngIf="item.reup_config?.schedule?.date">{{item.reup_config.schedule | scheduleDate}} {{item.reup_config.schedule.time}}</span>
              <span *ngIf="!item?.reup_config">Not scheduled yet</span>
            </div>
            <div *ngIf="item?.reup_config">
              <button type="button" class="btn btn-sm btn-secondary m-1" data-toggle="modal" data-target="#metaModal"
                (click)="getMeta(item)">Show</button>
              <button type="button" class="btn btn-sm btn-warning m-1"
                (click)="stopUpload(item)">Stop</button>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-between"
              *ngIf="item?.upload_status == 3 && item?.client_status != 0; else elseBlock">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [id]="'uploadLog_' + item.id"
                  (change)="chkDeleteVideo($event, 'search', item)">
                <label class="custom-control-label" [for]="'uploadLog_' + item.id">
                  <a class="text-truncate" rel="nofollow" target="_blank"
                    href="https://www.youtube.com/watch?v={{ item?.upload_log }}">
                    {{ item?.upload_log }}
                  </a>
                </label>
              </div>

              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-trash text-white-50 c-pointer" viewBox="0 0 16 16" (click)="deleteVideo('search', item)">
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
              </svg>
            </div>
            <ng-template #elseBlock>{{ item?.upload_log }}</ng-template>
          </td>
          <td class="font-weight-bold">{{ getMusicStatus(item) }}</td>
          <td>
            <span *ngIf="item?.type == 4" class="badge badge-pill badge-info mr-1">Test</span>
            <span class="badge badge-pill"
              [ngClass]="{ 'badge-danger': item?.status == 71 || (item?.status == 5 && item?.upload_status == 4), 'badge-success': item?.status == 6 || (item?.status == 5 && item?.upload_status == 3) || item?.status == 3, 'badge-primary': item?.status == 4, 'badge-info': item?.status == 2, 'badge-warning': item?.status == 7 || item?.status == 1 || item?.status == 0 }">
              {{ item?.status == 71 ? 'Render Error' : item?.status == 7 ? 'Stopped' : item?.status == 6 ? 'Scheduled' :
              item?.status == 5 && item?.upload_status == 4 ? 'Up Failed' : item?.status == 5 && item?.upload_status ==
              3 ? 'Uploaded' : item?.status == 4 ? 'Uploading' : item?.status == 3 ? 'Rendered' : item?.status == 2 ?
              'Running' : item?.status == 1 ? 'Assigned' : 'New' }}
            </span>
            <div *ngIf="item?.status == 71 || item?.upload_status == 4" class="mt-2">
              <button *ngIf="item?.status == 71" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                (click)="retryJob(item)">Retry Job</button>
              <button *ngIf="item?.upload_status == 4" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                (click)="retryUpload(item)">Retry Upload</button>
            </div>
            <div *ngIf="item?.type == 4 && item?.status == 3" class="mt-2">
              <button type="button" class="btn btn-sm btn-primary text-nowrap m-1" [disabled]="item?.isUploading" (click)="uploadNow(item)">Upload now</button>
            </div>
          </td>
          <td>
            <div class="progress" *ngIf="item?.render_percent != null">
              <div class="progress-bar progress-bar-striped bg-primary" role="progressbar"
                [style.width.%]="item?.render_percent | round:0" [attr.aria-valuenow]="item?.render_percent | round:0"
                aria-valuemin="0" aria-valuemax="100">
                {{ item?.render_percent | round:0 }}%
              </div>
            </div>
          </td>
          <td>
            <span class="{{ item?.success == 1 || item?.upload_status == 3 ? 'text-success' : 'text-danger' }}"
              *ngIf="item?.success != null || item?.upload_status != 0">
              {{ item?.success == 1 ? 'RENDER SUCCESS' : item?.upload_status == 3 ? 'UPLOAD SUCCESS' : 'ERROR' }}
            </span>
            <div *ngIf="item?.success != null && item?.success != 1 && item?.upload_status != 3">
              <button (click)="askError(item)" type="button" class="btn btn-sm btn-info mt-1" [disabled]="askErrorData.isLoading == item.id">
                <span *ngIf="askErrorData.isLoading == item.id" class="spinner-border spinner-border-sm"></span>
                <svg *ngIf="askErrorData.isLoading != item.id" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16">
                  <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
                </svg>
                Moon AI
              </button>
            </div>
          </td>
          <td>{{ item?.created }}</td>
          <td>{{ item?.crosspost_user }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <table class="table table-dark table-striped table-bordered table-hover" *ngIf="viewType == 0">
    <thead>
      <tr>
        <th scope="col">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-eye-fill c-pointer mr-2" viewBox="0 0 16 16" data-toggle="collapse" data-target=".collapse">
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
          </svg>
          Channel
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let c of channelList.slice(0, 100)">
        <tr *ngIf="job[c?.chanel_id]?.results.length" class="bg-secondary" [ngClass]="{ 'bg-danger' : isJobError(job[c?.chanel_id]?.results) }">
          <th class="d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
              class="bi bi-eye-fill c-pointer mr-2" viewBox="0 0 16 16" data-toggle="collapse"
              [attr.data-target]="'#collapse' + c?.chanel_id">
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
            </svg>

            <a class="text-light mr-2" rel="nofollow" target="_blank"
              href="https://www.youtube.com/channel/{{ c?.chanel_id }}">
              {{ c?.chanel_name }}
            </a>

            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
              class="bi bi-arrow-clockwise c-pointer mr-2" viewBox="0 0 16 16" (click)="reloadJob(c)">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
              <path
                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
            </svg>

            <a class="text-light d-flex align-self-center" target="_blank"
              href="/results?view={{ c?.chanel_id }},{{ c?.chanel_name }}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-arrow-up-right-square" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z" />
              </svg>
            </a>
          </th>
        </tr>
        <div *ngIf="job[c?.chanel_id]?.results.length" class="collapse show" [attr.id]="'collapse' + c?.chanel_id">
          <table class="w-100">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col">Video</th>
                <th scope="col">Thumbnail</th>
                <th scope="col">Meta upload</th>
                <th scope="col">
                  <div class="d-flex align-items-center justify-content-between">
                    Upload
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-trash text-danger c-pointer" viewBox="0 0 16 16" (click)="deleteVideos(c)"
                      *ngIf="deleteData[c?.chanel_id]?.video_ids?.length">
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </svg>
                  </div>
                </th>
                <th scope="col">Music status</th>
                <th scope="col">Job status</th>
                <th scope="col">Render progress</th>
                <th scope="col">Status</th>
                <th scope="col">Created</th>
                <th scope="col">Crosspost user</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of job[c?.chanel_id]?.results">
                <th scope="row">
                  <a class="text-light" target="_blank" href="/?loadId={{ item?.id }}">
                    {{ item?.id }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                      class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg>
                  </a>
                </th>
                <td>{{ item?.name }}</td>
                <td>
                  <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
                    [href]="item?.result?.startsWith('http') ? (item?.result | split:';;':0) : 'https://drive.google.com/file/d/' + (item?.result | split:';;':0) + '?sv=studio'">
                    Download
                  </a>
                  <button *ngIf="item?.result != '' && !item?.result?.startsWith('http')" (click)="archiveDrive(item)" title="Move to archive (ignore remove by system)"
                    class="btn btn-block btn-sm btn-secondary" type="button">Archive</button>
                </td>
                <td>
                  <a *ngIf="item?.result != ''" class="btn btn-block btn-sm btn-primary" rel="nofollow" target="_blank"
                    [href]="item?.result?.includes(';;http') ? (item?.result | split:';;':1) : 'https://drive.google.com/uc?id=' + (item?.result | split:';;':1)">
                    Download
                  </a>
                </td>
                <td>
                  <div class="font-weight-bold mb-2">
                    <span *ngIf="item.reup_config?.schedule?.date">{{item.reup_config.schedule | scheduleDate}} {{item.reup_config.schedule.time}}</span>
                    <span *ngIf="!item?.reup_config">Not scheduled yet</span>
                  </div>
                  <div *ngIf="item?.reup_config">
                    <button type="button" class="btn btn-sm btn-secondary m-1" data-toggle="modal" data-target="#metaModal"
                      (click)="getMeta(item)">Show</button>
                    <button type="button" class="btn btn-sm btn-warning m-1"
                      (click)="stopUpload(item)">Stop</button>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center justify-content-between"
                    *ngIf="item?.upload_status == 3 && item?.client_status != 0; else elseBlock">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" [id]="'uploadLog_' + item.id"
                        (change)="chkDeleteVideo($event, c, item)">
                      <label class="custom-control-label" [for]="'uploadLog_' + item.id">
                        <a class="text-truncate" rel="nofollow" target="_blank"
                          href="https://www.youtube.com/watch?v={{ item?.upload_log }}">
                          {{ item?.upload_log }}
                        </a>
                      </label>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-trash text-white-50 c-pointer" viewBox="0 0 16 16" (click)="deleteVideo(c, item)">
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </svg>
                  </div>
                  <ng-template #elseBlock>{{ item?.upload_log }}</ng-template>
                </td>
                <td class="font-weight-bold">{{ getMusicStatus(item) }}</td>
                <td>
                  <span *ngIf="item?.type == 4" class="badge badge-pill badge-info mr-1">Test</span>
                  <span class="badge badge-pill"
                    [ngClass]="{ 'badge-danger': item?.status == 71 || (item?.status == 5 && item?.upload_status == 4), 'badge-success': item?.status == 6 || (item?.status == 5 && item?.upload_status == 3) || item?.status == 3, 'badge-primary': item?.status == 4, 'badge-info': item?.status == 2, 'badge-warning': item?.status == 7 || item?.status == 1 || item?.status == 0 }">
                    {{ item?.status == 71 ? 'Render Error' : item?.status == 7 ? 'Stopped' : item?.status == 6 ? 'Scheduled' :
                    item?.status == 5 && item?.upload_status == 4 ? 'Up Failed' : item?.status == 5 &&
                    item?.upload_status == 3 ? 'Uploaded' : item?.status == 4 ? 'Uploading' : item?.status == 3 ?
                    'Rendered' : item?.status == 2 ? 'Running' : item?.status == 1 ? 'Assigned' : 'New' }}
                  </span>
                  <div *ngIf="item?.status == 71 || item?.upload_status == 4" class="mt-2">
                    <button *ngIf="item?.status == 71" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                      (click)="retryJob(item)">Retry Job</button>
                    <button *ngIf="item?.upload_status == 4" type="button" class="btn btn-sm btn-orange text-nowrap m-1"
                      (click)="retryUpload(item)">Retry Upload</button>
                  </div>
                  <div *ngIf="item?.type == 4 && item?.status == 3" class="mt-2">
                    <button type="button" class="btn btn-sm btn-primary text-nowrap m-1" [disabled]="item?.isUploading" (click)="uploadNow(item)">Upload now</button>
                  </div>
                </td>
                <td>
                  <div class="progress" *ngIf="item?.render_percent != null">
                    <div class="progress-bar progress-bar-striped bg-primary" role="progressbar"
                      [style.width.%]="item?.render_percent | round:0"
                      [attr.aria-valuenow]="item?.render_percent | round:0" aria-valuemin="0" aria-valuemax="100">
                      {{ item?.render_percent | round:0 }}%
                    </div>
                  </div>
                </td>
                <td>
                  <span class="{{ item?.success == 1 || item?.upload_status == 3 ? 'text-success' : 'text-danger' }}"
                    *ngIf="item?.success != null || item?.upload_status != 0">
                    {{ item?.success == 1 ? 'RENDER SUCCESS' : item?.upload_status == 3 ? 'UPLOAD SUCCESS' : 'ERROR' }}
                  </span>
                  <div *ngIf="item?.success != null && item?.success != 1 && item?.upload_status != 3">
                    <button (click)="askError(item)" type="button" class="btn btn-sm btn-info mt-1" [disabled]="askErrorData.isLoading == item.id">
                      <span *ngIf="askErrorData.isLoading == item.id" class="spinner-border spinner-border-sm"></span>
                      <svg *ngIf="askErrorData.isLoading != item.id" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16">
                        <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
                      </svg>
                      Moon AI
                    </button>
                  </div>
                </td>
                <td>{{ item?.created }}</td>
                <td>{{ item?.crosspost_user }}</td>
              </tr>
            </tbody>
          </table>
          <button type="button" class="btn btn-block btn-dark"
            *ngIf="job[c?.chanel_id]?.results.length && job[c?.chanel_id]?.page != -1"
            (click)="loadMore(job[c?.chanel_id]?.page, c, searched.value)">Load more</button>
        </div>
      </ng-container>
    </tbody>
  </table>
</div>

<div class="modal fade" id="metaModal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Meta</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="videoTitle">Title</label>
          <div class="d-flex align-items-center">
            <textarea #titleCopy class="form-control bg-dark border-secondary text-light" id="videoTitle" rows="1"
              [ngModel]="metaItem?.title"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="titleCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="videoDesc">Description</label>
          <div class="d-flex align-items-center">
            <textarea #descCopy class="form-control bg-dark border-secondary text-light" id="videoDesc" rows="5"
              [ngModel]="metaItem?.description"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="descCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="videoTags">Tags</label>
          <div class="d-flex align-items-center">
            <textarea #tagCopy class="form-control bg-dark border-secondary text-light" id="videoTags" rows="5"
              [ngModel]="metaItem?.tags"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="tagCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="videoTimestamp">Timestamp</label>
          <div class="d-flex align-items-center">
            <textarea class="form-control bg-dark border-secondary text-light" id="videoTimestamp" rows="5"
              [ngModel]="metaItem?.timestamp"></textarea>
            <div class="d-flex flex-column">
              <button type="button" class="btn btn-link" (click)="copyRealTimestamp()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                  viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy without missing">
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
              </button>
              <button (click)="genTimestampSRT()" type="button" class="btn btn-link" >
              <svg data-toggle="tooltip" data-placement="top" title="Download captions" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
              </svg>
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="jobAskErrorModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">{{ askErrorData?.error_type }}</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="mb-2">Error layer: <strong>{{ askErrorData?.error_layer }}</strong></div>
        <div>{{ askErrorData?.solution }}</div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>